import { useState, useEffect } from 'react';
import { Autocomplete, Box } from '@okta/odyssey-react-mui';
import { getOpportunities } from '../../services/DemoAPI';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from "react-i18next";

const OpportunityPicker = ({
    allowEdit,
    selectionChanged
}) => {
    const { t } = useTranslation();
  const [ opportunities, setOpportunities ] = useState();
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    async function fetchOpportunities() {
      try {
        const data = await getOpportunities(await getAccessTokenSilently())
        setOpportunities(data.data);
      } catch (err) {
        setOpportunities([]);
      }
    }
    fetchOpportunities();
  }, [getAccessTokenSilently,setOpportunities]);


  function buildOptions(opportunities) {
    const options = [];
    opportunities?.forEach((element) => {
        options.push({
          label: element.name,
          id: element.opportunity_id,
        });
    });

    return options;
  }

  function onChange(event, value) {
    event.stopPropagation();
    selectionChanged(value.id);
  }

  if (opportunities === undefined) {
    return (
      <Box sx={{ marginBottom: '1.14285714rem;'}}>
          <Autocomplete
            label={t('opportunity-picker-label', {ns: 'events'})}
            hint={t('opportunity-picker-hint', {ns: 'events'})}
            placeholder={t('opportunity-picker-placeholder', {ns: 'events'})}
            id="opportunities"
            name="opportunities"
            onChange={onChange}
            options={[]}
            isReadOnly={!allowEdit}
            isDisabled={!allowEdit} 
            isLoading={true}           
          />
        </Box>
    );
  } else {
    return (
        <Box sx={{ marginBottom: '1.14285714rem;'}}>
          <Autocomplete
            label={t('opportunity-picker-label', {ns: 'events'})}
            hint={t('opportunity-picker-hint', {ns: 'events'})}
            placeholder={t('opportunity-picker-placeholder', {ns: 'events'})}
            id="opportunities"
            name="opportunities"
            onChange={onChange}
            options={buildOptions(opportunities)}
            isReadOnly={!allowEdit}
            isDisabled={!allowEdit} 
          />
        </Box>
    );
  }
};
export default OpportunityPicker;
